import { ExtractAtomicOperationFromDefinition } from "../../atomic-operations";
import { GridLayoutId } from "../../idTypeBrands";
import { SemanticCap } from "../../semanticCaps.js";
import { createHexVersionAtomicOperationDefinition } from "../HexVersionAtomicOperationDefinition";

import { CREATE_GRID_LAYOUT } from "./createGridLayoutOperation";

export const DELETE_GRID_LAYOUT_TYPE = "DELETE_GRID_LAYOUT" as const;
export const DELETE_GRID_LAYOUT = createHexVersionAtomicOperationDefinition({
  type: DELETE_GRID_LAYOUT_TYPE,
  readAuth: {
    kind: "hasSemanticCap",
    cap: SemanticCap.VIEW_PROJECT_CONTENTS_FOR_LOGIC,
  },
  writeAuth: {
    kind: "hasSemanticCapOnIdArg",
    idArg: "gridLayoutId",
    idType: "GridLayout",
    cap: SemanticCap.EDIT_PROJECT_CONTENTS,
  },
  logSafe: ["gridLayoutId"],
  conflictId: (op) => `${CREATE_GRID_LAYOUT.type}-${op.payload.gridLayoutId}`,
  create: ({ gridLayoutId }: { gridLayoutId: GridLayoutId }) => ({
    type: DELETE_GRID_LAYOUT_TYPE,
    payload: {
      gridLayoutId,
    },
  }),
});

export type DELETE_GRID_LAYOUT = ExtractAtomicOperationFromDefinition<
  typeof DELETE_GRID_LAYOUT
>;
